export enum TvFeature {
  'BROWSE_TITLES' = 'BROWSE_TITLES',
  'RECOMMENDATIONS' = 'RECOMMENDATIONS',
  'WATCHLIST' = 'WATCHLIST',
  'VOICE' = 'VOICE',
}

export type TvFeatureKey = keyof typeof TvFeature;
